module.exports = __webpack_public_path__ + "img/image13-3.88f86716.jpeg";